var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tag,{tag:"component",staticClass:"border border-solid box-border flex cursor-pointer justify-center items-center",style:({
    'min-width': _vm.px(_vm.size),
    'max-width': _vm.px(_vm.size),
    'min-height': _vm.px(_vm.size),
    'max-height': _vm.px(_vm.size),
    'border-radius': _vm.borderRadius,
    ..._vm.currentStyles
  })},[(_vm.marked)?[(_vm.type === 'check')?_c('CSSCheckIcon',{staticStyle:{"margin-bottom":"14%"},attrs:{"color":"white","width":4,"height":9}}):_vm._e(),_vm._v(" "),(_vm.type === 'cross')?_c('Icon',{attrs:{"size":"20px","name":"close-cross","color":_vm.$tokens.color_white}}):_vm._e()]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }